const basePath = window?.baseAppConfig?.basePath;
const contextUrl = window?.location?.href;
const contextOrigin = window?.location?.origin;
const classicPath = window?.baseAppConfig?.appendToReturnLink;
const classicIdentifier = window?.baseAppConfig?.classicIdentifier;

export default function checkForRedirect() {
  if (isClassicNewRedirect()) {
    return;
  }
  if (isPathRedirect()) {
    return;
  }
  if (isLegacyUrl()) {
    redirectFromLegacy();
  }
}

function isClassicNewRedirect() {
  if (window?.baseAppConfig?.redirectClassicUrls && isLegacyUrl()) {
    redirectToClassic();
    return true;
  }
  if (window?.baseAppConfig?.redirectNewUrls && contextUrl.includes('/new')) {
    redirectNewUrls();
    return true;
  }
  return false;
}

function isPathRedirect() {
  if (contextUrl.includes('#/admin/settings/integrations')) {
    redirectIntegrations();
    return true;
  }
  if (contextUrl.includes('/invite/')) {
    redirectInviteLink();
    return true;
  }
  if (contextUrl.includes('reset_password=true') && !contextUrl.includes('reset_password?')) {
    redirectPasswordResetLink();
    return true;
  }
  if (contextUrl.includes('/pending_hire')) {
    redirectPendingHiresLink();
    return true;
  }
  return false;
}

function isLegacyUrl() {
  return contextUrl.includes(classicIdentifier) && !contextUrl.includes(classicPath);
}

export function isAwsHosted() {
  return `${basePath}` === '/';
}

export function getClassicUrlFor(urlOrPath = contextUrl) {
  const destinationPath = urlOrPath.includes(classicIdentifier) ? urlOrPath.split(classicIdentifier)[1] : urlOrPath;
  const newPath = `/${classicPath}${classicIdentifier}${destinationPath}`;
  const pathname = newPath.replaceAll('//', '/');
  const classicUrl = `${contextOrigin}${pathname}`;
  return classicUrl;
}

function redirectToClassic() {
  const classicUrl = getClassicUrlFor(contextUrl);
  window.location.replace(classicUrl);
}

function redirectFromLegacy() {
  const destinationPathWithClassicRemoved = contextUrl.replace(classicIdentifier, '/');
  if (isAwsHosted()) {
    window.location.replace(destinationPathWithClassicRemoved);
    return;
  }
  const actualDestinationPath = destinationPathWithClassicRemoved.replace(`${basePath}/`, `${basePath}`);
  window.location.replace(actualDestinationPath);
}

function redirectNewUrls() {
  const newPath = isAwsHosted() ? '/hr/new' : '/new';
  let destinationPath = contextUrl.replace(`${newPath}/`, '/');
  destinationPath = destinationPath.replace(newPath, '/');
  window.location.replace(destinationPath);
}

function redirectInviteLink() {
  const destinationPath = contextUrl.split('invite')[0].replace(classicIdentifier, '/');
  const inviteId = contextUrl.split('invite/')[1];
  const newInvitePath = `${destinationPath}preboarding?inviteId=${inviteId}`;
  window.location.replace(newInvitePath);
}

function redirectPasswordResetLink() {
  const params = contextUrl.split('?')[1];
  window.location.replace(`${contextOrigin}${basePath}reset_password?${params}`);
}

function redirectPendingHiresLink() {
  const destinationPath = contextUrl.split('#/admin/pending_hire')[0];
  const newPendingHiresPath = `${destinationPath}administration/pending-hires`;
  window.location.replace(newPendingHiresPath);
}

function redirectIntegrations() {
  const params = contextUrl.split('?')[1];
  const destinationPath = contextUrl.split('#/admin/settings/integrations')[0];
  const newIntegrationPath = `${destinationPath}administration/integrations-page?${params}`;
  window.location.replace(newIntegrationPath);
}
